module.exports = __webpack_public_path__ + "static/media/Modena.962776f8.png";